import React from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'
import type AtsCompany from 'modules/ats/store/models/AtsCompany'
import LanguageSelector from 'modules/settings/components/LanguageSelector'

interface Props {
  atsCompany: AtsCompany | null | undefined
}

class AtsForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      locale: 'string',
    })
  }
}

export const Customize = observer(({ atsCompany }: Props) => {
  const { navigation } = useNavigation()
  const { atsEnabled } = useAtsEnabled()
  const [atsForm] = React.useState(new AtsForm({ locale: atsCompany?.attributes.locale }))

  useEffect(() => {
    if (atsEnabled && atsCompany) {
      atsForm.setValues({
        locale: atsCompany.attributes.locale,
      })
      atsForm.cleanAll()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { performAction } = useAsyncAction(
    async () => {
      if (!atsCompany) return

      await atsForm.save(atsCompany)
    },
    {
      errorFlash: false,
    }
  )

  const navigateToCareersCustomizator = () => {
    const path = navigation.careers.fullPath()
    const hostname = window.location.hostname
    const protocol = window.location.protocol
    window.open(`${protocol}//${hostname}${path}`, '_blank')
  }

  if (!atsCompany) return null

  return (
    <Section.Form
      illustration="design-studio"
      title={i18n.t('company_settings.general.company_page.options.customize.title')}
      description={i18n.t('company_settings.general.company_page.options.customize.description')}
      action={{
        onClick: navigateToCareersCustomizator,
        label: i18n.t('company_settings.general.company_page.options.customize.open_customizer'),
      }}
      onSubmit={performAction}
      isDirty={atsForm.isDirty}
      submitLabel={i18n.t('common.submit')}
    >
      <LanguageSelector
        label={i18n.t(
          'company_settings.general.company_page.options.customize.language_selector_label'
        )}
        form={atsForm}
      />
    </Section.Form>
  )
})
